import { IGetRestricoesPainelObraUseCase } from "../../../presentation/useCases/read/get_restricoes_painel_obra_use_case";
import { RestricoesPainelObra } from "../../models/restricoes_painel_obra";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetRestricoesPainelObraUseCase
 */

export class GetRestricoesPainelObraUseCase implements IGetRestricoesPainelObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async execute(): Promise<RestricoesPainelObra> {
    return await this.repository.getRestricoesPainelObra();
  }
}
